import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import {
  setupPaymentMethod,
  SetupPaymentMethodProps,
} from "../services/paymentMethods";
import { PaymentMethodType } from "../types";

export const usePaymentMethodSetup = (
  props: SetupPaymentMethodProps<PaymentMethodType> & { enabled: boolean }
) => {
  const {
    data: setupConfig,
    isLoading,
    isSuccess,
  } = useDataQuery(
    ["paymentMethodSetupConfig", props],
    async () => {
      try {
        const data = await setupPaymentMethod(props);

        return data;
      } catch (error) {
        console.error(error);
      }
    },
    {
      enabled: props.enabled,
    }
  );

  return {
    setupConfig,
    isLoading,
    isSuccess,
  };
};
